/**
 * Created by Astha on 12/22/2017.
 */
import React from 'react';
import PropTypes from 'prop-types';

export default class LabelWithValueField extends React.Component {
  static propTypes = {
    labelName: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    style: PropTypes.object,
    value: PropTypes.string.isRequired,
    typeOfInput: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      term: ''
    };
  }

  render() {
    const { labelName, style, value, onChange, typeOfInput } = this.props;

    return (
      <div style={style}>
        <label style={styles.label}>{labelName}</label>
        <input
          type={typeOfInput}
          style={styles.valueField}
          value={value}
          onChange={(event) => {
            onChange(event.target.value);
          }}
        />
      </div>
    );
  }
}
const styles = {
  label: {
    height: '15px',
    color: '#B5B5B5',
    fontFamily: 'Montserrat',
    fontSize: '12px',
    fontWeight: 600,
    letterSpacing: '1px',
    lineHeight: '15px',
    marginLeft: '5px',
    paddingTop: '20px'
  },
  valueField: {
    width: '98%',
    padding: '0.5em',
    color: 'var(--input-box-font-color)',
    border: 'none',
    fontFamily: 'Montserrat',
    borderRadius: '2px',
    backgroundColor: 'var(--primary-header-bg)',
    boxShadow: '0 1px 4px 0 rgba(0,0,0,0.04)',
    fontSize: '16px',
    marginTop: '10px'
  }
};
